export default "__VITE_ASSET__BgEampFU__"